export default "__VITE_ASSET__CMyGyh8q__";